import React from 'react';
import {PasswordField} from '../../../utility/form';
import LoadingButton from '../../../utility/button/LoadingButton';
import useResetPassword from './useResetPassword';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const ResetPassword = () => {
  const {
  form,
  onChange,
  onSubmit,
  loading,
  errors,
} = useResetPassword();
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="auth-card mx-auto">
      <h3 className="text-center fw-bold mb-1">{t('resetPassword.title')}</h3>
      <div className="text-center forgot-sub-heading" style={{fontSize: '0.8rem', marginBottom: 20 }}>
        {t('resetPassword.subtitle')}
      </div>
      <form onSubmit={onSubmit} noValidate>
        <div className="mb-2">
          <PasswordField
            label={t('resetPassword.password')}
            name="password"
            value={form.password}
            onChange={onChange}
            error={errors.password}
            placeholder={t('resetPassword.passwordPlaceholder')}
            type="password"
          />
        </div>
        <div className="mb-4">
          <PasswordField
            label={t('resetPassword.confirmPassword')}
            name="password_confirmation"
            value={form.password_confirmation}
            onChange={onChange}
            error={errors.password_confirmation}
            placeholder={t('resetPassword.confirmPasswordPlaceholder')}
            type="password"
          />
        </div>
        <LoadingButton
            type="submit"
            disabled={loading}
            isLoading={loading}
            className="w-100"
          >
          {t('resetPassword.submit')}
        </LoadingButton>
      </form>
    </div>
  );
};

export default ResetPassword;
